import { useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { FaArrowRight } from "react-icons/fa";
import imgeleven from "../../assets/img/imgeleven.png";
import Shake from "react-reveal/Shake";

const testimonials = [
  {
    id: 1,
    name: "Amaka E.",
    text: "My son looks forward to every session! He's more confident with tech now, and I'm impressed by how fun the learning is.",
    avatar: imgeleven,
  },
  {
    id: 2,
    name: "Mr. Tunde A.",
    text: "Cephas Kids Tech Xtra is the best decision we made. The tutors are patient, and the content is very practical.",
    avatar: imgeleven,
  },
  {
    id: 3,
    name: "Aisha M.",
    text: "My daughter created her first animation last week — at 9! This program is turning dreams into skills.",
    avatar: imgeleven,
  },
  {
    id: 4,
    name: "John D.",
    text: "Amazing program! My child learned so much in just a few weeks. Highly recommend to all parents.",
    avatar: imgeleven,
  },
  {
    id: 5,
    name: "Sarah K.",
    text: "The instructors are fantastic and really know how to engage kids. My daughter loves every session!",
    avatar: imgeleven,
  },
];

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex(
      (prev) => (prev - 1 + testimonials.length) % testimonials.length
    );
  };

  // Get visible testimonials based on screen size
  const getVisibleTestimonials = (count) => {
    const visible = [];
    for (let i = 0; i < count; i++) {
      const index = (currentIndex + i) % testimonials.length;
      visible.push(testimonials[index]);
    }
    return visible;
  };

  return (
    <section className="py-16 px-5 md:px-10 lg:px-32 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <Shake>
            <h2 className="text-3xl md:text-4xl lg:text-4xl font-DM_SANS font-bold text-[#1B1B1B] mb-4">
              Hear What They're Saying{" "}
              <span className="text-[#FF4B01]">About Us</span>
            </h2>
          </Shake>
        </div>

        <div data-aos="flip-up" data-aos-duration="2000" className="relative">
          {/* Small screens - 1 card */}
          <div className="block md:hidden">
            <div className="grid grid-cols-1 gap-8">
              {getVisibleTestimonials(1).map((testimonial, index) => (
                <div
                  key={`${testimonial.id}-${index}`}
                  className="bg-white rounded-2xl p-8 shadow-sm border border-[#FF4B0199]/60 text-center"
                >
                  <div className="w-20 h-20 mx-auto mb-6">
                    <img
                      src={testimonial.avatar}
                      alt={testimonial.name}
                      className="w-full h-full rounded-full object-cover"
                    />
                  </div>
                  <div className="justify-center flex items-center">
                    <p className="text-[#475569] font-DM_SANS font-normal w-44 text-base mb-2">
                      "{testimonial.text}"
                    </p>
                  </div>
                  <div className="flex justify-center items-center">
                    <div className="h-[1px] w-[40px] bg-[#FF4B01]"></div>
                  </div>
                  <div className="pt-4">
                    <p className="font-normal text-base font-DM_SANS text-[#000000]">
                      {testimonial.name}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Medium screens - 2 cards */}
          <div className="hidden md:block lg:hidden">
            <div className="grid grid-cols-2 gap-8">
              {getVisibleTestimonials(2).map((testimonial, index) => (
                <div
                  key={`${testimonial.id}-${index}`}
                  className="bg-white rounded-2xl p-8 shadow-sm border border-[#FF4B0199]/60 text-center"
                >
                  <div className="w-20 h-20 mx-auto mb-6">
                    <img
                      src={testimonial.avatar || "/placeholder.svg"}
                      alt={testimonial.name}
                      className="w-full h-full rounded-full object-cover"
                    />
                  </div>
                  <div className="justify-center flex items-center">
                    <p className="text-[#475569] font-DM_SANS font-normal w-44 text-base mb-2">
                      "{testimonial.text}"
                    </p>
                  </div>
                  <div className="flex justify-center items-center">
                    <div className="h-[1px] w-[40px] bg-[#FF4B01]"></div>
                  </div>
                  <div className="pt-4">
                    <p className="font-normal text-base font-DM_SANS text-[#000000]">
                      {testimonial.name}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Large screens - 3 cards */}
          <div className="hidden lg:block">
            <div className="grid grid-cols-3 gap-8">
              {getVisibleTestimonials(3).map((testimonial, index) => (
                <div
                  key={`${testimonial.id}-${index}`}
                  className="bg-white rounded-2xl p-8 shadow-sm border border-[#FF4B0199]/60 text-center"
                >
                  <div className="w-20 h-20 mx-auto mb-6">
                    <img
                      src={testimonial.avatar || "/placeholder.svg"}
                      alt={testimonial.name}
                      className="w-full h-full rounded-full object-cover"
                    />
                  </div>
                  <div className="justify-center flex items-center">
                    <p className="text-[#475569] font-DM_SANS font-normal w-44 text-base mb-2">
                      "{testimonial.text}"
                    </p>
                  </div>
                  <div className="flex justify-center items-center">
                    <div className="h-[1px] w-[40px] bg-[#FF4B01]"></div>
                  </div>
                  <div className="pt-4">
                    <p className="font-normal text-base font-DM_SANS text-[#000000]">
                      {testimonial.name}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={prevTestimonial}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-white rounded-full p-3 shadow-lg hover:shadow-xl transition-shadow duration-200"
          >
            <FaArrowLeft className="w-6 h-6 text-gray-600" />
          </button>

          <button
            onClick={nextTestimonial}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-white rounded-full p-3 shadow-lg hover:shadow-xl transition-shadow duration-200"
          >
            <FaArrowRight className="w-6 h-6 text-gray-600" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;

// import { useState } from "react";
// import { FaArrowLeft } from "react-icons/fa";
// import { FaArrowRight } from "react-icons/fa";
// import imgeleven from "../../assets/img/imgeleven.png";

// const testimonials = [
//   {
//     id: 1,
//     name: "Amaka E.",
//     text: "My son looks forward to every session! He's more confident with tech now, and I'm impressed by how fun the learning is.",
//     avatar: imgeleven,
//   },
//   {
//     id: 2,
//     name: "Mr. Tunde A.",
//     text: "Cephas Kids Tech Xtra is the best decision we made. The tutors are patient, and the content is very practical.",
//     avatar: imgeleven,
//   },
//   {
//     id: 3,
//     name: "Aisha M.",
//     text: "My daughter created her first animation last week — at 9! This program is turning dreams into skills.",
//     avatar: imgeleven,
//   },
// ];

// const Testimonials = () => {
//   const [currentIndex, setCurrentIndex] = useState(0);

//   const nextTestimonial = () => {
//     setCurrentIndex((prev) => (prev + 1) % testimonials.length);
//   };

//   const prevTestimonial = () => {
//     setCurrentIndex(
//       (prev) => (prev - 1 + testimonials.length) % testimonials.length
//     );
//   };

//   const getVisibleTestimonials = () => {
//     const visible = [];
//     for (let i = 0; i < 3; i++) {
//       const index = (currentIndex + i) % testimonials.length;
//       visible.push(testimonials[index]);
//     }
//     return visible;
//   };

//   return (
//     <section className="py-16 px-5 md:px-10 lg:px-32 bg-white">
//       <div className="max-w-7xl mx-auto">
//         <div className="text-center mb-12">
//           <h2 className="text-3xl md:text-4xl lg:text-4xl font-DM_SANS font-bold text-[#1B1B1B] mb-4">
//             Hear What They're Saying{" "}
//             <span className="text-[#FF4B01]">About Us</span>
//           </h2>
//         </div>

//         <div className="relative">
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//             {getVisibleTestimonials().map((testimonial, index) => (
//               <div
//                 key={`${testimonial.id}-${index}`}
//                 className="bg-white rounded-2xl p-8 shadow-sm border border-[#FF4B0199]/60 text-center"
//               >
//                 <div className="w-20 h-20 mx-auto mb-6">
//                   <img
//                     src={testimonial.avatar}
//                     alt={testimonial.name}
//                     className="w-full h-full rounded-full object-cover"
//                   />
//                 </div>
//                 <div className=" justify-center flex items-center">
//                   <p className="text-[#475569] font-DM_SANS font-normal w-44 text-base mb-2">
//                     "{testimonial.text}"
//                   </p>
//                 </div>

//                 <div className=" flex justify-center items-center">
//                   <div className=" h-[1px] w-[40px] bg-[#FF4B01]"></div>
//                 </div>

//                 <div className=" pt-4">
//                   <p className="font-normal text-base font-DM_SANS text-[#000000]">
//                     {testimonial.name}
//                   </p>
//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* Navigation Arrows */}
//           <button
//             onClick={prevTestimonial}
//             className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-white rounded-full p-3 shadow-lg hover:shadow-xl transition-shadow duration-200"
//           >
//             <FaArrowLeft className="w-6 h-6 text-gray-600" />
//           </button>

//           <button
//             onClick={nextTestimonial}
//             className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-white rounded-full p-3 shadow-lg hover:shadow-xl transition-shadow duration-200"
//           >
//             <FaArrowRight className="w-6 h-6 text-gray-600" />
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Testimonials;
